import React from 'react';
import '../App.css';
import {
  FaStethoscope,
  FaAmbulance,
  FaHeartbeat,
  FaBaby,
  FaMicroscope,
  FaSyringe,
  FaUserMd,
  FaBriefcaseMedical,
  FaWheelchair,
  FaRegHospital
} from 'react-icons/fa';
import Header from '../Components/Header'; // ✅ Use shared header component if available

const Services = () => {
  const services = [
    {
      icon: <FaStethoscope className="service-icon" />,
      title: 'General Consultation',
      description: 'Get accurate diagnosis and personalized treatment plans from our experienced physicians.'
    },
    {
      icon: <FaAmbulance className="service-icon" />,
      title: 'Emergency Care (24/7)',
      description: 'Our emergency department is open round-the-clock to handle all urgent and critical care cases.'
    },
    {
      icon: <FaUserMd className="service-icon" />,
      title: 'Surgical Procedures',
      description: 'Minor and major surgeries with advanced equipment and a team of expert surgeons.'
    },
    {
      icon: <FaMicroscope className="service-icon" />,
      title: 'Laboratory & Diagnostics',
      description: 'Quick and reliable lab tests, imaging, and screenings with latest diagnostic tools.'
    },
    {
      icon: <FaHeartbeat className="service-icon" />,
      title: 'Cardiology',
      description: 'Heart health care including ECG, ECHO, and expert treatment for cardiac conditions.'
    },
    {
      icon: <FaBaby className="service-icon" />,
      title: 'Pediatrics',
      description: 'Health care for infants, toddlers, and children including vaccinations and routine check-ups.'
    },
    {
      icon: <FaSyringe className="service-icon" />,
      title: 'Gynaecology & Maternity',
      description: 'Comprehensive care for women’s health, pregnancy, childbirth, and postnatal care.'
    },
    {
      icon: <FaWheelchair className="service-icon" />,
      title: 'Physiotherapy',
      description: 'Recovery assistance and mobility improvement through personalized therapy programs.'
    },
    {
      icon: <FaBriefcaseMedical className="service-icon" />,
      title: 'Free PMKVY Card Services',
      description: 'We accept PMKVY cards for government-funded treatments, surgeries, and tests.'
    },
    {
      icon: <FaRegHospital className="service-icon" />,
      title: 'Ambulance Support (24/7)',
      description: 'Emergency ambulance available anytime with fast response across Bahadurgarh & Patiala.'
    }
  ];

  return (
    <div className="services-page">
      {/* ✅ Use shared header */}
      {Header ? <Header /> : (
        <header>
          <nav className="navbar">
            <div className="logo">
              <h1>Chaman Hospital</h1>
            </div>
            <ul className="nav-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/services" className="active">Services</a></li>
              <li><a href="/doctors">Doctors</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </nav>
        </header>
      )}

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2>Our Medical Services</h2>
          <p className="subtitle">
            We offer a wide range of medical services to ensure your health and well-being. Our expert doctors and staff are dedicated to providing you with the best care.
          </p>

          <div className="services-list">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                {service.icon}
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Services;
